import ModuleWrapper from '@/components/page/ModuleWrapper';

const Postbacks = () => import(/* webpackChunkName: "postbacks" */ '@/views/Postbacks/Postbacks');
const meta = (data = {}) => ({
    moduleName: 'postbacks',
    auth: true,
    ...data,
});

export default [{
    path: 'postbacks',
    component: ModuleWrapper,
    meta: meta({
        title: 'Postbacks',
    }),
    children: [
        {
            path: '',
            name: 'Postbacks',
            props: true,
            component: Postbacks,
            meta: meta({}),
        },
    ],
}];
